import { stateNeighbors, stateLinkMap, allStateLinks, type StateLink } from "./data";

interface StatePillsProps {
  state: string;
}

function getStatePills(state: string): StateLink[] {
  if (state === "all") {
    return allStateLinks;
  }

  const current = stateLinkMap.get(state);
  if (!current) {
    return allStateLinks;
  }

  const neighbors = stateNeighbors[state] ?? [];
  const neighborLinks = neighbors
    .map((abbr) => stateLinkMap.get(abbr))
    .filter((s): s is StateLink => s !== undefined);

  return [current, ...neighborLinks];
}

export default function StatePills({ state }: StatePillsProps) {
  const pills = getStatePills(state);
  if (pills.length === 0) return null;

  return (
    <div className="mb-8">
      <div className="flex flex-wrap gap-2 items-center justify-center">
        {pills.map((s) => (
          <a
            key={s.route}
            href={s.route}
            title={`${s.name} Passport Services — Expedited & Emergency`}
            className="inline-flex items-center gap-1 text-sm text-[#1A365D] hover:text-[#F6C344] font-semibold transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-4 py-2 whitespace-nowrap"
          >
            <i className="ri-map-pin-2-line text-[#F6C344]"></i>
            {s.label} <i className="ri-arrow-right-line text-xs"></i>
          </a>
        ))}
      </div>
    </div>
  );
}